export function parseCertification(json) {
  return {
    certificationQuestionId: json.IdCertificationQuestion,
    certificationUserId: json.IdCertificationUser,
    certificationUserQuestionId: json.IdCertificationUserQuestion,
    formId: json.IdForm,
    supplierId: json.IdSupplier,
    certificationId: json.IdCertification,
    certificationTitle: json.Name,
    columns: (json?.Columns || []).map((column) => ({
      name: column.Name,
      data: column.Data,
      type: column.Type,
    })),
    answer: JSON.parse(json?.ReviewJson),
  };
}
